import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, BodyText, CaptionText, Badge, PreferredSelectedIcon, Divider, HeadingText, LoadingSpinner, ContextualAlert, Button } from '@paypalcorp/pp-react';

function styleInject$1(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".styles-module_title__exTx3 {\n  margin-bottom: 52px;\n}\n.styles-module_showMore__AjopN {\n  text-align: center;\n}\n.styles-module_donorList__n4HJ0 {\n  margin: 0;\n  padding: 0;\n}\n.styles-module_container__SRhpS {\n  display: flex;\n  padding: 12px 0px;\n  margin-bottom: 16px;\n}\n.styles-module_avatar__ClcMc {\n  flex-shrink: 0;\n  margin-right: 12px;\n}\ndiv.styles-module_anonymous__iDOF8 {\n  background-color: #25694f !important;\n}\n.styles-module_anonymous__iDOF8 svg:first-of-type {\n  color: #cbf3ec;\n}\n.styles-module_details__0zbF8 {\n  flex-grow: 1;\n}\n.styles-module_detailsRow__IEUgF {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.styles-module_shimmerDetails__3p-QH > div:first-of-type {\n  margin-bottom: 6px;\n}\n.styles-module_date__svSd3 {\n  color: #515354 !important;\n  margin-top: 7px;\n  text-transform: capitalize;\n}\n.styles-module_amount__cJ6-h {\n  flex-shrink: 0;\n}\n.styles-module_note__Breg5 {\n  color: #515354;\n  background-color: #f7f5f0;\n  border-radius: 2px 8px 8px 8px;\n  display: inline-block;\n  margin-top: 12px;\n  padding: 14px 12px;\n  word-break: break-word;\n}\n";
var styles$1 = {"title":"styles-module_title__exTx3","showMore":"styles-module_showMore__AjopN","donorList":"styles-module_donorList__n4HJ0","container":"styles-module_container__SRhpS","avatar":"styles-module_avatar__ClcMc","anonymous":"styles-module_anonymous__iDOF8","details":"styles-module_details__0zbF8","detailsRow":"styles-module_detailsRow__IEUgF","shimmerDetails":"styles-module_shimmerDetails__3p-QH","date":"styles-module_date__svSd3","amount":"styles-module_amount__cJ6-h","note":"styles-module_note__Breg5"};
styleInject$1(css_248z$1);

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = "div.styles-module_anonymous__iDOF8 {\n  background-color: #005400 !important;\n}\n.styles-module_anonymous__iDOF8 svg:first-of-type {\n  color: #d4f490;\n}\n";
var styles = {
  "anonymous": "styles-module_anonymous__iDOF8"
};
styleInject(css_248z);
function extractUserInitials(userName) {
  // split the names using space as delimiter
  var splitNames = userName.split(/ +/g).filter(function (e) {
    return e;
  });
  // first name - straight forward
  var firstName = splitNames.length > 0 ? splitNames[0] : null;
  // last name - if user has middle name, consider last element as last name
  var lastName = splitNames.length > 1 ? splitNames[splitNames.length - 1] : null;
  var initials;
  if (firstName) {
    initials = firstName[0];
  }
  if (lastName) {
    initials = "".concat(initials).concat(lastName[0]);
  }
  return initials;
}
function DonorAvatar(_ref) {
  var _ref$isAnonymousAvata = _ref.isAnonymousAvatar,
    isAnonymousAvatar = _ref$isAnonymousAvata === void 0 ? false : _ref$isAnonymousAvata,
    name = _ref.name,
    photo = _ref.photo,
    color = _ref.color,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isAnonymousAvatar ? /*#__PURE__*/React.createElement(Avatar, {
    generic: "profile",
    color: "green",
    size: size,
    className: className ? "".concat(styles.anonymous, " ").concat(className) : styles.anonymous
  }) : /*#__PURE__*/React.createElement(Avatar, {
    src: photo,
    initials: extractUserInitials(name),
    color: color,
    size: size,
    className: className ? className : {}
  }));
}
DonorAvatar.propTypes = {
  isAnonymousAvatar: PropTypes.bool,
  name: PropTypes.string,
  photo: PropTypes.string,
  color: PropTypes.string,
  theme: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string
};

function DonorRow(_ref) {
  var name = _ref.name,
    photo = _ref.photo,
    color = _ref.color,
    time = _ref.time,
    note = _ref.note,
    amount = _ref.amount,
    shareDonorInfo = _ref.shareDonorInfo,
    anonymousLabel = _ref.anonymousLabel,
    badgeType = _ref.badgeType,
    firstLabel = _ref.firstLabel,
    topLabel = _ref.topLabel,
    isPreviewMode = _ref.isPreviewMode,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'v2' : _ref$theme;
  var showAnonymousAvatar = !(shareDonorInfo && !isPreviewMode);
  return /*#__PURE__*/React.createElement("li", {
    className: styles$1.container
  }, /*#__PURE__*/React.createElement(DonorAvatar, {
    photo: photo,
    name: name,
    color: color,
    isAnonymousAvatar: showAnonymousAvatar,
    className: styles$1.avatar,
    size: "sm"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$1.details
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.detailsRow
  }, /*#__PURE__*/React.createElement(BodyText, {
    theme: theme
  }, shareDonorInfo || isPreviewMode ? name : anonymousLabel), /*#__PURE__*/React.createElement(BodyText, {
    className: styles$1.amount,
    theme: theme
  }, amount)), /*#__PURE__*/React.createElement("div", {
    className: styles$1.detailsRow
  }, /*#__PURE__*/React.createElement(CaptionText, {
    className: styles$1.date,
    theme: theme
  }, time), badgeType === 'TOP' || badgeType === 'FIRST' ? /*#__PURE__*/React.createElement(Badge, {
    type: "feature",
    leftIcon: PreferredSelectedIcon,
    leftIconLabel: "V2PreferredFilledIcon"
  }, badgeType === 'FIRST' ? firstLabel : topLabel) : null), note ? /*#__PURE__*/React.createElement(CaptionText, {
    className: styles$1.note,
    theme: theme
  }, note) : null));
}
DonorRow.propTypes = {
  name: PropTypes.string,
  photo: PropTypes.string,
  color: PropTypes.string,
  time: PropTypes.string,
  note: PropTypes.string,
  amount: PropTypes.string,
  shareDonorInfo: PropTypes.bool,
  anonymousLabel: PropTypes.string,
  badgeType: PropTypes.string,
  firstLabel: PropTypes.string,
  topLabel: PropTypes.string,
  isPreviewMode: PropTypes.bool,
  theme: PropTypes.string
};

function ShimmerRow() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$1.container
  }, /*#__PURE__*/React.createElement(Avatar, {
    isLoading: true,
    size: "sm",
    className: styles$1.avatar
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles$1.details, " ").concat(styles$1.shimmerDetails)
  }, /*#__PURE__*/React.createElement(BodyText, {
    size: "hero",
    isLoading: true
  }), /*#__PURE__*/React.createElement(CaptionText, {
    size: "hero",
    isLoading: true
  })));
}

function Shimmer(_ref) {
  var loadingLabel = _ref.loadingLabel;
  return /*#__PURE__*/React.createElement("div", {
    role: "alert",
    "aria-label": loadingLabel
  }, /*#__PURE__*/React.createElement(ShimmerRow, null), /*#__PURE__*/React.createElement(ShimmerRow, null), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ShimmerRow, null));
}
Shimmer.propTypes = {
  loadingLabel: PropTypes.string
};

function DonorWall(_ref) {
  var _ref$content = _ref.content,
    title = _ref$content.title,
    loading = _ref$content.loading,
    showMore = _ref$content.showMore,
    ariaLabel = _ref$content.ariaLabel,
    anonymous = _ref$content.anonymous,
    first = _ref$content.first,
    top = _ref$content.top,
    paginationLimitMessage = _ref$content.paginationLimitMessage,
    contributions = _ref.contributions,
    handleShowMore = _ref.handleShowMore,
    totalTransactions = _ref.totalTransactions,
    currentPage = _ref.currentPage,
    transactionsPerPage = _ref.transactionsPerPage,
    isLoading = _ref.isLoading,
    _ref$isPreviewMode = _ref.isPreviewMode,
    isPreviewMode = _ref$isPreviewMode === void 0 ? false : _ref$isPreviewMode,
    paginationLimit = _ref.paginationLimit;
  function renderShowMore() {
    if (isLoading && currentPage !== 1) {
      return /*#__PURE__*/React.createElement(LoadingSpinner, {
        screenReaderText: loading,
        style: {
          margin: '0 auto'
        }
      });
    } else if (currentPage * transactionsPerPage < totalTransactions) {
      if (paginationLimit && paginationLimit <= currentPage && paginationLimitMessage.length > 0) {
        return /*#__PURE__*/React.createElement(ContextualAlert, {
          type: "warning"
        }, paginationLimitMessage);
      }
      return /*#__PURE__*/React.createElement(Button, {
        tertiary: true,
        onClick: handleShowMore
      }, showMore);
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading && currentPage === 1 ? /*#__PURE__*/React.createElement(Shimmer, {
    loadingLabel: loading
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeadingText, {
    size: "sm",
    className: styles$1.title
  }, title), contributions.featured.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: styles$1.donorList
  }, contributions.featured.map(function (txn) {
    var _txn$photos$6$url, _txn$photos, _txn$photos$;
    return /*#__PURE__*/React.createElement(DonorRow, {
      key: txn.id,
      photo: (_txn$photos$6$url = (_txn$photos = txn.photos) === null || _txn$photos === void 0 ? void 0 : (_txn$photos$ = _txn$photos[6]) === null || _txn$photos$ === void 0 ? void 0 : _txn$photos$.url) !== null && _txn$photos$6$url !== void 0 ? _txn$photos$6$url : '',
      name: txn.donor_name,
      color: txn.color,
      time: txn.formattedDate,
      note: txn.memo,
      amount: txn.formattedAmount,
      shareDonorInfo: txn.shareDonorInfo,
      anonymousLabel: anonymous,
      badgeType: txn.badge,
      firstLabel: first,
      topLabel: top,
      isPreviewMode: isPreviewMode
    });
  })), /*#__PURE__*/React.createElement(Divider, null)) : null, /*#__PURE__*/React.createElement("ul", {
    className: styles$1.donorList,
    "aria-label": ariaLabel
  }, contributions.list.map(function (txn) {
    var _txn$photos$6$url2, _txn$photos2, _txn$photos2$;
    return contributions.featured.some(function (i) {
      return i.id === txn.id;
    }) ? null : /*#__PURE__*/React.createElement(DonorRow, {
      key: txn.id,
      photo: (_txn$photos$6$url2 = (_txn$photos2 = txn.photos) === null || _txn$photos2 === void 0 ? void 0 : (_txn$photos2$ = _txn$photos2[6]) === null || _txn$photos2$ === void 0 ? void 0 : _txn$photos2$.url) !== null && _txn$photos$6$url2 !== void 0 ? _txn$photos$6$url2 : '',
      name: txn.donor_name,
      color: txn.color,
      time: txn.formattedDate,
      note: txn.memo,
      amount: txn.formattedAmount,
      shareDonorInfo: txn.shareDonorInfo,
      anonymousLabel: anonymous,
      isPreviewMode: isPreviewMode
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1.showMore
  }, renderShowMore())));
}
DonorWall.propTypes = {
  content: PropTypes.shape({
    loading: PropTypes.string,
    title: PropTypes.string,
    showMore: PropTypes.string,
    ariaLabel: PropTypes.string,
    anonymous: PropTypes.string,
    first: PropTypes.string,
    top: PropTypes.string,
    paginationLimitMessage: PropTypes.string
  }),
  contributions: PropTypes.object,
  handleShowMore: PropTypes.func,
  currentPage: PropTypes.number,
  transactionsPerPage: PropTypes.number,
  totalTransactions: PropTypes.number,
  isLoading: PropTypes.bool,
  isPreviewMode: PropTypes.bool,
  paginationLimit: PropTypes.number
};

export { DonorWall };
